var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"menu-bgs"},_vm._l((_vm.menuBg),function(item,i){return _c('li',{directives:[{name:"bg-img",rawName:"v-bg-img",value:(item),expression:"item"}],key:i,class:['menu-bg', _vm.isActiveMenuBg === i ? 'show' : '']})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }